import apiFetch from './apiFetch';

/**
 * AOI (Area-of-Interest) coastal wave-height points.
 * Source CSV served by the data server (port 1313):
 *   /aoiwaveheight-csv/Combined_Mw900_Extract_Muti-Values.csv
 *
 * ⚠ PERFORMANCE: each magnitude CSV is ~7 MB (all cases combined).
 * For production, pre-split per scenario (e.g. /aoi-json/Mw900_C093.json)
 * so the browser only loads ~17 points per scenario.
 */

const _cache = new Map(); // mw -> parsed rows

export function aoiCsvUrl(mw) {
  return `/aoiwaveheight-csv/Combined_${mw}_Extract_Muti-Values.csv`;
}

export function waveHeightColor(v) {
  if (v == null || v <= 0) return null;
  if (v < 0.2)  return '#CCFFFF';
  if (v < 1.0)  return '#FFFFCC';
  if (v < 3.0)  return '#FFCC00';
  if (v < 5.0)  return '#FF8C00';
  if (v < 10.0) return '#FF2200';
  return '#8B0000';
}

function parseCsv(text) {
  const lines = text.split(/\r?\n/);
  const rows = [];
  for (let i = 1; i < lines.length; i++) {
    if (!lines[i]) continue;
    const f = lines[i].split(',');
    if (f.length < 13) continue;
    rows.push({
      location: f[0],
      label: f[1],
      lat: +f[2],
      lon: +f[3],
      mw: f[10],
      caseCode: f[11],
      zmax: +f[12],
    });
  }
  return rows;
}

export async function loadAoiPoints(scenarioId, namedOnly = true) {
  const m = scenarioId.match(/^(Mw\d+)_(C\d+)$/);
  if (!m) return [];
  const [, mw, caseCode] = m;

  let rows = _cache.get(mw);
  if (!rows) {
    const res = await apiFetch(aoiCsvUrl(mw));
    if (!res.ok) throw new Error(`AOI CSV HTTP ${res.status}`);
    rows = parseCsv(await res.text());
    _cache.set(mw, rows);
  }

  return rows
    .filter(r => r.caseCode === caseCode)
    .filter(r => (namedOnly ? r.label && r.label !== '#N/A' : true))
    .map(r => ({ name: r.label, lat: r.lat, lon: r.lon, h: r.zmax }));
}
